import {
    ItemType,
    columnModeNumColumns,
    headerHeight,
    productCellHeight,
    productRowHeight,
    productSpacing,
    separatorHeight,
} from '@/features/pos/components/ProductCatalog/parts/ProductList/constants'
import Container from '@/features/pos/components/ProductCatalog/parts/ProductList/parts/Container'
import Product from '@/features/pos/components/ProductCatalog/parts/ProductList/parts/Product'
import ProductSkeleton from '@/features/pos/components/ProductCatalog/parts/ProductList/parts/ProductSkeleton'
import SectionHeader from '@/features/pos/components/ProductCatalog/parts/ProductList/parts/SectionHeader'
import { productStyles } from '@/features/pos/components/ProductCatalog/parts/ProductList/styles'
import { ExtraData, Item } from '@/features/pos/components/ProductCatalog/parts/ProductList/types'
import { ListRenderItem } from '@shopify/flash-list'
import { ViewStyle } from 'react-native'

export const getItemSpacingMargins = (index: number, numColumns: number): ViewStyle => {
    const colIndex = index % numColumns

    const marginLeft = colIndex > 0 ? productSpacing / 2 : 0
    const marginRight = colIndex < numColumns - 1 ? productSpacing / 2 : 0

    return { marginLeft, marginRight }
}

export const renderItem: ListRenderItem<Item> = ({ item, index, extraData }) => {
    const { mode, numColumns, itemStylesByColumn } = extraData as ExtraData

    const isGrid = mode === 'grid'
    const productMode = isGrid ? 'cell' : 'row'

    let colIndex = index % numColumns

    if (item === null) {
        return <ProductSkeleton mode={productMode} style={itemStylesByColumn[colIndex]} />
    }

    if (item.type === ItemType.Header)
        return <SectionHeader style={productStyles.product}>{item.name}</SectionHeader>

    colIndex = item.index % numColumns

    const style = itemStylesByColumn[colIndex]

    if (item.type === ItemType.Container) {
        return (
            <Container
                mode={productMode}
                id={item.id}
                name={item.name}
                price={item.price}
                style={style}
            />
        )
    }

    return (
        <Product
            mode={productMode}
            id={item.id}
            name={item.name}
            price={item.price}
            soldOut={item.soldOut}
            variantQuantity={item.variantQuantity}
            labelName={item.label?.name}
            labelColor={item.label?.color}
            style={style}
        />
    )
}

export const keyExtractor = (item: Item, index: number): string => {
    if (item === null) return `${ItemType.Skeleton}_${item}_${index}`

    if (item.type === ItemType.Header) return `${ItemType.Header}_${item.name}_${index}`

    return `${item.type}_${item.id}_${index}`
}

export const getItemType = (item: Item): ItemType => {
    if (item === null) return ItemType.Skeleton

    return item.type
}

export const overrideItemLayout = (
    layout: { span?: number; size?: number },
    item: Item,
    _: any,
    _1: any,
    { mode, numColumns }: ExtraData
) => {
    const isHeader = item?.type === ItemType.Header

    const isColumn = mode === 'column'

    const productHeight = isColumn ? productRowHeight : productCellHeight

    layout.span = isHeader ? numColumns : isColumn ? columnModeNumColumns : 1
    layout.size = isHeader ? headerHeight + separatorHeight : productHeight + separatorHeight
}
